"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4506],{

/***/ 12160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BasicBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79105);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);








var BasicBlockComponent = function BasicBlockComponent(props) {
  var children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "block" : _props$styleKey,
      _props$backgroundStyl = props.backgroundStyleKey,
      backgroundStyleKey = _props$backgroundStyl === void 0 ? "primary" : _props$backgroundStyl;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    css: [blockStyle[styleKey], backgroundStyle[backgroundStyleKey],  true ? "" : 0,  true ? "" : 0],
    children: children
  });
};

var BasicBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(BasicBlockComponent);
var blockStyle = {
  block: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page1col */ .k.page1col, ";margin:0 auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockWide: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page1colWide */ .k.page1colWide, ";margin:0 auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockFullWidth: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " 0;max-width:100%;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockMultiCol: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";margin:0 auto;max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page2col */ .k.page2col, ";box-sizing:border-box;}" + ( true ? "" : 0),  true ? "" : 0),
  blockMultiColWide: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";margin:0 auto;max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page2colWide */ .k.page2colWide, ";box-sizing:border-box;}" + ( true ? "" : 0),  true ? "" : 0)
};
var backgroundStyle = {
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)( true ? "" : 0,  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary2: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("background-color:", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, -2), ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 26079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MainBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


var _excluded = ["backgroundStyleKey", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var MainBlock = function MainBlock(props) {
  var _props$backgroundStyl = props.backgroundStyleKey,
      backgroundStyleKey = _props$backgroundStyl === void 0 ? "primary" : _props$backgroundStyl,
      children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    css: [blockStyle, backgroundStyle[backgroundStyleKey],  true ? "" : 0,  true ? "" : 0]
  }, rest), {}, {
    children: children
  }));
};
var blockStyle =  true ? {
  name: "1khn195",
  styles: "box-sizing:border-box"
} : 0;
var backgroundStyle = {
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)( true ? "" : 0,  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)("background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 99615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* unused harmony export cardStyle */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96749);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);


var _excluded = ["children", "minHeightStyle", "styleKey", "overflowStyle", "borderStyle", "marginStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Card = function Card(props) {
  var children = props.children,
      _props$minHeightStyle = props.minHeightStyle,
      minHeightStyle = _props$minHeightStyle === void 0 ? "188px" : _props$minHeightStyle,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "card" : _props$styleKey,
      _props$overflowStyle = props.overflowStyle,
      overflowStyle = _props$overflowStyle === void 0 ? "hidden" : _props$overflowStyle,
      _props$borderStyle = props.borderStyle,
      borderStyle = _props$borderStyle === void 0 ? "none" : _props$borderStyle,
      marginStyle = props.marginStyle,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  var cardStyles = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(cardStyle[styleKey], ";min-height:", minHeightStyle, ";overflow:", overflowStyle, ";border:", borderStyle, ";", marginStyle && "margin: ".concat(marginStyle, ";"), ";" + ( true ? "" : 0),  true ? "" : 0);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    css: cardStyles
  }, rest), {}, {
    children: children
  }));
};
var cardBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("display:flex;flex-direction:column;min-height:188px;overflow:hidden;position:relative;background:rgb(255, 255, 255);border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_3__/* .borderRadius.normal */ .E.normal, ";box-sizing:border-box;margin:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var cardStyle = {
  card: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(cardBaseStyle, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__/* .moreThanBreakpoint */ .h6)("tablet"), "{flex-direction:row;}" + ( true ? "" : 0),  true ? "" : 0),
  cardNoHover: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(cardBaseStyle, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__/* .moreThanBreakpoint */ .h6)("tablet"), "{flex-direction:row;}" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 4325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ CardImage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./main/javascripts/hooks/useImageLoad.ts

var useImageLoad = function useImageLoad(url) {
  var _useState = (0,react.useState)(false),
      loaded = _useState[0],
      setLoaded = _useState[1];

  (0,react.useEffect)(function () {
    setLoaded(false);
    var img = new Image();
    img.src = url;

    var handleLoad = function handleLoad() {
      return setLoaded(true);
    };

    if (img.complete) {
      setLoaded(true);
    } else {
      img.addEventListener("load", handleLoad);
    }

    return function () {
      img.removeEventListener("load", handleLoad);
    };
  }, [url]);
  return loaded;
};
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/card/CardImage.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var CardImage = function CardImage(props) {
  var url = props.url;
  var loaded = useImageLoad(url);
  var cardImageStyles = loaded ? cardImageLoadedStyle : cardImageStyle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: cardImageBlockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
      css: cardImageStyles,
      src: url,
      alt: ""
    })
  });
};
var cardImageBlockStyle =  true ? {
  name: "2uxe3e",
  styles: "background-color:rgb(220, 220, 220);box-sizing:border-box;width:100%;height:100%;display:flex"
} : 0;
var cardImageStyle =  true ? {
  name: "1nrcj0o",
  styles: "width:100%;height:100%;object-fit:cover;opacity:0;flex:1;transition:opacity 0.4s ease"
} : 0;
var cardImageLoadedStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)(cardImageStyle, ";opacity:1;" + ( true ? "" : 0),  true ? "" : 0);

/***/ })

}]);